define(
({
	invalidMessage: "输入的值无效。",
	missingMessage: "该值是必需的。",
	rangeMessage: "此值超出范围。"
})
);
